import type { PayloadAction } from '@reduxjs/toolkit';
import type { Middleware } from 'redux';

import { Cookies } from 'react-cookie-consent';

const cookieHandler: Middleware = () => (next) => (action) => {
  if ((action as PayloadAction).type === 'app/changeConsent') {
    Cookies.remove('_ga');
    Cookies.remove('_gat');
    Cookies.remove('_gid');
  }

  return next(action);
};

export default cookieHandler;
